import { apiHandler, apiWithSnackbar } from "../apiService";
import { authResourcs as authResources } from "./resources";

export const authServices = {
  changePassword: async (ids:string,data: ChangePasswordPayload) => {
      const resource = authResources.CHANGE_PASSWORD;
      const params = {
        resource: {
          ...resource,
          URL: `${resource.URL}/${ids}`,  
        },
        data,
      };
      return await apiHandler(params);
  },
  setTransPass: async () => {
    const params = {
      resource: authResources.SET_TRANS,
    };
    return await apiHandler(params);
  },
  telegramCode: async (data: TeleCode) => {
    const params = {
      resource: authResources.TELEGRAM_CODE,
      data,
    };
    return await apiHandler(params);
  },
 getUserUplineLockStatus: async (data:uplineLockPayload) => {
        const params = {
            resource: authResources.UPLINE_LOCK_STATUS,
            data
        };
        return await apiHandler(params);
    },
 updateLimit: async (data:uplineLimitPayload) => {
        const params = {
            resource: authResources.UPDATE_LIMITS,
            data
        };
        return await apiHandler(params);
    },
    diamondGamesLockList: async (data:uplineLockPayload) => {
        const params = {
            resource: authResources.DIAMOND_GAMES_LOCK_LIST,
            data
        };
        return await apiHandler(params);
    },
  getExposureSport: async (data: expSport) => {
    const params = {
      resource: authResources.GET_EXPOSURE_SPORT,
      data,
    };
    return await apiWithSnackbar(params);
  },
  getExposureSportV1: async (data: expSport) => {
    const params = {
      resource: authResources.GET_EXPV1_SPORT,
      data,
    };
    return await apiWithSnackbar(params);
  },


  getExposureCasino: async (data: expCasino) => {
    const params = {
      resource: authResources.GET_CASINO_EXPOSURE,
      data,
    };
    return await apiWithSnackbar(params);
  },
  getExposureQtech: async (data: expCasino) => {
    const params = {
      resource: authResources.QTECH_EXPOSURES,
      data,
    };
    return await apiWithSnackbar(params);
  },

  showBalance: async (data: Balance) => {
    const params = {
      resource: authResources.SHOW_BALANCE,
      data,
    };
    return await apiWithSnackbar(params);
  },
  getSportList: async () => {
    const params = {
      resource: authResources.GET_SPORT,

    };
    return await apiWithSnackbar(params);
  },
  getSportData: async (data: SportDataPayload) => {
    const params = {
      resource: authResources.GET_SPORT_DATA,
      data,

    };
    return await apiWithSnackbar(params);
  },
  getNews: async () => {
    const params = {
      resource: authResources.GET_NEWS,
    };
    return await apiWithSnackbar(params);
  },
  getSeriesData: async (data: SeriesDataPayload) => {
    const params = {
      resource: authResources.GET_SERIES,
      data
    };
    return await apiWithSnackbar(params);
  },

  getEnabaledFancy: async (data: enableFancy) => {
    const params = {
      resource: authResources.ENABLED_FANCY,
      data
    };
    return await apiWithSnackbar(params);
  },

  updateMatchStatus: async (data: updateMatchStatus) => {
    const params = {
      resource: authResources.UPDATE_MATCH_STATUS,
      data
    };
    return await apiHandler(params);
  },
  updateEvent: async (data: UpdateEventList) => {
    const params = {
      resource: authResources.UPDATE_EVENT,
      data
    };
    return await apiHandler(params);
  },

  validToken: async () => {
    const params = {
      resource: authResources.VALID_TOKEN
    };
    return await apiWithSnackbar(params);
  },
  getMatchedDetails: async (data: matchDetailsPayload) => {
    const params = {
      resource: authResources.GET_MATCHDETAILS,
      data
    };
    return await apiWithSnackbar(params);
  },
  getMatchedDetailsRunner: async (data: matchDetailsRunnerPayload) => {
    const params = {
      resource: authResources.GET_MATCHDETAILS_RUNNER,
      data
    };
    return await apiWithSnackbar(params);
  },
  getFancyData: async (data: matchDetailsPayload) => {
    const params = {
      resource: authResources.FANCY_DATA,
      data
    };
    return await apiWithSnackbar(params);
  },
  getFancyLiveData: async (data: matchDetailsPayload) => {
    const params = {
      resource: authResources.FANCY_LIVE_DATA,
      data
    };
    return await apiWithSnackbar(params);
  },
  getBets: async (data: BetsPayload) => {
    const params = {
      resource: authResources.BETS,
      data
    };
    return await apiWithSnackbar(params);
  },
  getOnlineFancy: async (data: matchedIdd) => {
    const params = {
      resource: authResources.GETONLINE_FANCY,
      data
    };
    return await apiWithSnackbar(params);
  },
  updateFancyStatus: async (data: UpdateStatus) => {
    const params = {
      resource: authResources.UPDATE_FANCY_STATUS,
      data
    };
    return await apiWithSnackbar(params);
  },
  updateFancy: async (data: Update_fancy) => {
    const params = {
      resource: authResources.UPDATE_FANCY,
      data
    };
    return await apiWithSnackbar(params);
  },
  getTeamPosition: async (data: matchedIdds) => {
    const params = {
      resource: authResources.GET_TEAM_POSITION,
      data
    };
    return await apiWithSnackbar(params);
  },
  getLimits: async (data: matchedIdd) => {
    const params = {
      resource: authResources.GET_LIMIT,
      data
    };
    return await apiWithSnackbar(params);
  },
  
  updateLimits: async (data: updateLimits) => {
    const params = {
      resource: authResources.UPDATE_LIMITS,
      data
    };
    return await apiHandler(params);
  },

  oddsAbondoned: async (data: oddsReq) => {
    const params = {
      resource: authResources.ODDS_ABONDONED,
      data
    };
    return await apiWithSnackbar(params);
  },
  updateMarketStatus: async (data: marketStatusRes) => {
    const params = {
      resource: authResources.UPDATE_MARKET_STATUS,
      data
    };
    return await apiWithSnackbar(params);
  },
  getMarketPosition: async (data: getMarketPayload) => {
    const params = {
      resource: authResources.GET_MARKET_POSITION,
      data
    };
    return await apiWithSnackbar(params);
  },
  getAddUserDetails: async (data: AddUsePayload) => {
    const params = {
      resource: authResources.ADD_USER,
      data
    };
    return await apiWithSnackbar(params);
  },
  getUserRegister: async (data: any) => {
    const params = {
      resource: authResources.USER_REGISTER,
      data
    };
    return await apiWithSnackbar(params);
  },
  getCloseUser: async (data: closeUser) => {
    const resource = authResources.GET_CLOSE_USER;
    const params = {
      resource: {
        ...resource,
        URL: `${resource.URL}`,  
      },
      data,
    };
    return await apiWithSnackbar(params);
  },
  getClose: async (data: closeUserPayload) => {
    const params = {
      resource: authResources.GET_CLOSE,
      data
    };
    return await apiHandler(params);
  },
  getUserListData: async (userId: string, data: closeUser) => {
    const resource = authResources.USER_LIST_WITH_CHILD;
    const params = {
      resource: {
        ...resource,
        URL: `${resource.URL}/${userId}`,  
      },
      data,
    };
    return await apiHandler(params);
  },
  getShowPass: async (data: ShowPassPay) => {
    const params = {
      resource: authResources.SHOW_PASSWORD,
      data
    };
    return await apiHandler(params);
  },
  getUpdateChildPass: async (data: chnagePaeePay) => {
    const params = {
      resource: authResources.UPDATE_CHILD_PASS,
      data
    };
    return await apiHandler(params);
  },
  getUserDetailsParent: async (data: string) => {
    const params = {
      resource: {
        URL:`/user/getUserDetailsWithParentDetails/${data}`,
        METHODS:"GET"
      },
      data
    };
    return await apiHandler(params);
  },
  getChipsOut: async (data: ChipsPayload) => {
    const params = {
      resource: authResources.CHIPS_OUT,
      data
    };
    return await apiHandler(params);
  },
  getCommittion: async (data: ShowPassPay) => {
    const params = {
      resource: authResources.GET_COMMITTION,
      data
    };
    return await apiHandler(params);
  },
  getUpdateCommittion: async (data: updateProps) => {
    const params = {
      resource: authResources.UPDATE_COMMITTION,
      data
    };
    return await apiHandler(params);
  },
  getLogo: async (data:logoPayload) => {
    const params = {
      resource: authResources.GET_LOGO,
      data
    };
    return await apiHandler(params);
  },
  getUpdateCr: async (data:updateCRPayload) => {
    const params = {
      resource: authResources.UPADATE_CR,
      data
    };
    return await apiHandler(params);
  },
  getMultiLogin: async (data:userLockPaylod) => {
    const params = {
      resource: authResources.ALLOW_MULTI_LOGIN,
      data
    };
    return await apiHandler(params);
  },
  getBetlock: async (data:userLockPaylod) => {
    const params = {
      resource: authResources.ALLOW_BETLOCK_LOCK,
      data
    };
    return await apiHandler(params);
  },
  getFancyBetlock: async (data:userLockPaylod) => {
    const params = {
      resource: authResources.ALLOW_FANCYLOCK_LOCK,
      data
    };
    return await apiHandler(params);
  },
  getFancyBetUnlock: async (data:userLockPaylod) => {
    const params = {
      resource: authResources.ALLOW_FANCYUNLOCK_LOCK,
      data
    };
    return await apiHandler(params);
  },
  getUserLock: async (data:userLockPaylod) => {
    const params = {
      resource: authResources.USER_ACC_LOCK,
      data
    };
    return await apiHandler(params);
  },
  getCloseAcc: async (data:userLockPaylod) => {
    const params = {
      resource: authResources.CLOSE_ACCOUNT,
      data
    };
    return await apiHandler(params);
  },
  getEventLock: async (data:userLockPaylod) => {
    const params = {
      resource: authResources.EVENT_LOCK,
      data
    };
    return await apiHandler(params);
  },
  getPartnerShip: async (data:userLockPaylod) => {
    const params = {
      resource: authResources.GET_PAETNERSHIP_LIST,
      data
    };
    return await apiHandler(params);
  },
  getUpdatePartbership: async (data:SportPaylod) => {
    const params = {
      resource: authResources.UPDATE_PARTNERSHIP,
      data
    };
    return await apiHandler(params);
  },
  getHorseRacing: async (data:horsePayload) => {
    const params = {
      resource: authResources.HORSE_RACING,
      data
    };
    return await apiHandler(params);
  },
  getMarketByCountryCode: async (data:horseMarkletIDs) => {
    const params = {
      resource: authResources.MARKETCODE_BY_COUNTRY,
      data
    };
    return await apiHandler(params);
  },
  getEventLimits: async (data:eventPayload) => {
    const params = {
      resource: authResources.GET_EVENT_LIMIT,
      data
    };
    return await apiHandler(params);
  },
  getDeleteBet: async (data:DeletePayload) => {
    const params = {
      resource: authResources.DELETE_BET,
      data
    };
    return await apiHandler(params);
  },
  getUserLimits: async (data:userSettingPayload) => {
    const params = {
      resource: authResources.USER_SETTING,
      data
    };
    return await apiHandler(params);
  },
  getUserSettingUpdate: async (data:updateUserSetting) => {
    const params = {
      resource: authResources.USER_SETTING_UPDATE,
      data
    };
    return await apiWithSnackbar(params);
  },
  getAllWebsite: async () => {
    const params = {
      resource: authResources.GET_ALL_WEBSITE,
    };
    return await apiHandler(params);
  },
  getUpdateStack: async (data:any) => {
    const params = {
      resource: authResources.UPDATE_STACK,
      data
    };
    return await apiHandler(params);
  },
  getShowAgent: async (data:showAgent) => {
    const params = {
      resource: authResources.SHOW_AGENT,
      data
    };
    return await apiHandler(params);
  },
  getActiveLog: async (data:activeLogsPayload) => {
    const params = {
      resource: authResources.GET_ACTIVE_LOG,
      data
    };
    return await apiHandler(params);
  },
  getAllUserLogout: async (data:any) => {
    const params = {
      resource: authResources.GET_ALL_LOGOUT,
      data
    };
    return await apiHandler(params);
  },
  getSportListData: async (data:any) => {
    const params = {
      resource: authResources.GET_SPORT_LIST,
      data
    };
    return await apiHandler(params);
  },
  getMatchesData: async (data:matchPayload) => {
    const params = {
      resource: authResources.GET_MATCHES,
      data
    };
    return await apiHandler(params);
  },
  getUpdateSportServices: async (data:UpdateStatusPaylod) => {
    const params = {
      resource: authResources.UPDATE_SPORT_STATUS,
      data
    };
    return await apiHandler(params);
  },
  getMarketData: async (data:MatchesPayload) => {
    const params = {
      resource: authResources.GET_MARKET,
      data
    };
    return await apiHandler(params);
  },
  getSeriesUpdate: async (data:SeriesUpdatePayload) => {
    const params = {
      resource: authResources.GET_UPDATE_SERIES_STATUS,
      data
    };
    return await apiHandler(params);
  },
  getCreateSeries: async (data:createSeriesPayload) => {
    const params = {
      resource: authResources.CREATE_SERIES,
      data
    };
    return await apiHandler(params);
  },
  createMatched: async (data:CreateMatchPayload) => {
    const params = {
      resource: authResources.CREATE_MATCH,
      data
    };
    return await apiHandler(params);
  },
  getTvScore: async (data:tvPaylod) => {
    const params = {
      resource: authResources.GET_TV_SCORE,
      data
    };
    return await apiHandler(params);
  },
  getUpdateUrl: async (data:tvUpdatePaylod) => {
    const params = {
      resource: authResources.UPDATE_TV_URL,
      data
    };
    return await apiHandler(params);
  },
  getAgentUserList: async (data:UserListPayload) => {
    const params = {
      resource: authResources.AGENT_USER_LIST,
      data
    };
    return await apiHandler(params);
  },
  getStatementList: async (data:StatementPayload) => {
    const params = {
      resource: authResources.STATEMENT_LIST,
      data
    };
    return await apiHandler(params);
  },
  getChipSummaryList: async (data: any) => {
    const params = {
      resource: authResources.CHIP_SUMMARY_LIST,
      data
    };
    return await apiHandler(params);
  },
  getChipSummaryHistory: async (data: ChipSummaryHistoryPayload) => {
    const params = {
      resource: authResources.CHIP_SUMMARY_HISTORY,
      data
    };
    return await apiHandler(params);
  },
  getChipSettlement: async (data: ChipSettlementPayload) => {
    const params = {
      resource: authResources.CHIP_SETTLEMENT,
      data
    };
    return await apiHandler(params);
  },
  getCasinoBets: async (data: CasinoBetsPayload) => {
    const params = {
      resource: authResources.CASINO_BETS,
      data
    };
    return await apiHandler(params);
  },
  getEventPl: async (data: EventPlPayload) => {
    const params = {
      resource: authResources.EVENT_PL,
      data
    };
    return await apiHandler(params);
  },
  eventWisePlReport: async (data: EventWiseReportPlPayload) => {
    const params = {
      resource: authResources.EVENTWISEPLREPORT,
      data
    };
    return await apiHandler(params);
  },
  usersPLByMarket: async (data: USERSPLBYMARKETPAYLOAD) => {
    const params = {
      resource: authResources.USERSPLBYMARKET,
      data
    };
    return await apiHandler(params);
  },
  getPlMarketWise: async (data: MARKET_WISE_EVENTS_PLPayload) => {
    const params = {
      resource: authResources.MARKET_WISE_EVENTS_PL,
      data
    };
    return await apiHandler(params);
  },
  getUsersPLByMarket: async (data: UserWisePlPayload) => {
    const params = {
      resource: authResources.USER_WISE_PL,
      data
    };
    return await apiHandler(params);
  },
  getsetteledBet: async (data: UserSettledBetPayload) => {
    const params = {
      resource: authResources.SETTLED_BETS,
      data
    };
    return await apiHandler(params);
  },
  getPlMatchWise: async (data: MatchWisePlPayload) => {
    const params = {
      resource: authResources.MATCHWISE_PL,
      data
    };
    return await apiHandler(params);
  },
  getProfitLossList: async (data: ProfitLossPayload) => {
    const params = {
      resource: authResources.PROFIT_LOSS,
      data
    };
    return await apiHandler(params);
  },
  getSportsSearchList: async (data: ProfitLossPayload) => {
    const params = {
      resource: authResources.SPORTS_SEARCH,
      data
    };
    return await apiHandler(params);
  },
  geOpenBetsList: async (data: ProfitLossPayload) => {
    const params = {
      resource: authResources.OPEN_BETS,
      data
    };
    return await apiHandler(params);
  },
  getSettledBetsList: async (data: ProfitLossPayload) => {
    const params = {
      resource: authResources.SETTLED_BETS,
      data
    };
    return await apiHandler(params);
  },
  getBetHistoryList: async (data: BetHistoryPayload) => {
    const params = {
      resource: authResources.SETTLED_BETS,
      data
    };
    return await apiHandler(params);
  },
  getSportWisePL: async (data: SportWisePayload) => {
    const params = {
      resource: authResources.SPORTS_WISE_PL,
      data
    };
    return await apiHandler(params);
  },
  getFancyPLList: async (data: ProfitLossPayload) => {
    const params = {
      resource: authResources.FANCY_PL,
      data
    };
    return await apiHandler(params);
  },
  getFancyStackUserWise: async (data: FancyStakePayload) => {
    const params = {
      resource: authResources.FANCY_STAKE_USER_WISE,
      data
    };
    return await apiHandler(params);
  },
  getFancyTotalStackUserWise: async (data: FancyTotalStakePayload) => {
    const params = {
      resource: authResources.FANCY_TOTAL_STAKE_USER_WISE,
      data
    };
    return await apiHandler(params);
  },
  getUserNews: async (data: NewsPayload) => {
    const params = {
      resource: authResources.GET_NEWS,
      data
    };
    return await apiHandler(params);
  },
  createNews: async (data: CreateNewsPayload) => {
    const params = {
      resource: authResources.CREATE_NEWS,
      data
    };
    return await apiHandler(params);
  },
  deleteNews: async () => {
    const params = {
      resource: authResources.DELETE_NEWS,
      data: {}
    };
    return await apiHandler(params);
  },
  myMarket: async (data: MarketPayload) => {
    const params = {
      resource: authResources.MY_MARKET,
      data
    };
    return await apiHandler(params);
  },
  getSocketStatus: async () => {
    const params = {
      resource: authResources.SOCKET_STATUS,
      data: {}
    };
    return await apiHandler(params);
  },
  updateSocketStatus: async () => {
    const params = {
      resource: authResources.UPDATE_SOCKET,
      data: {}
    };
    return await apiHandler(params);
  },
  getMatchStack: async (data: MarketPayload) => {
    const params = {
      resource: authResources.MATCH_STACK,
      data
    };
    return await apiHandler(params);
  },
  updateRedishFlush: async () => {
    const params = {
      resource: authResources.REDISH_FLUSH,
      data: {}
    };
    return await apiHandler(params);
  },
  getEventBlock: async (data:marktBlockPayload) => {
    const params = {
      resource: authResources.EVENT_BLOCK,
      data
    };
    return await apiHandler(params);
  },
  getTvScoreUrl: async (data:tvPayload) => {
    const params = {
      resource: authResources.TV_SCORE,
      data
    };
    return await apiHandler(params);
  },
  getFancyLabilaty: async (data:tvPayload) => {
    const params = {
      resource: authResources.GET_FANCY_LABILATY,
      data
    };
    return await apiHandler(params);
  },
  // getFancyLabilatySheare: async (data:tvPayload) => {
  //   const params = {
  //     resource: authResources.GET_FANCIES_LABILATY,
  //     data
  //   };
  //   return await apiHandler(params);
  // },
  getFancyRunTime: async (data:fancyRunTime) => {
    const params = {
      resource: authResources.GET_RUN_TIME_FANCY,
      data
    };
    return await apiHandler(params);
  },
  getUserStackValue: async (data:userStackPayload) => {
    const params = {
      resource: authResources.GET_USER_MATCH_STACK,
      data
    };
    return await apiHandler(params);
  },
  getUserList: async (data: UserSearchListPayload) => {
    const params = {
      resource: authResources.GET_USER_LIST,
      data
    };
    return await apiHandler(params);
  },
  getwalletDWTransactionList: async (data: WalletDWTransactionList) => {
    const params = {
      resource: authResources.Wallet_DW_Transaction,
      data
    };
    return await apiHandler(params);
  },
  getFraudBets: async (data: FraudBetsPayload) => {
    const params = {
      resource: authResources.GET_FRAUD_BETS,
      data
    };
    return await apiWithSnackbar(params);
  },
  getDisableTelegramOtp: async (data: DisableTelegramOtp) => {
    const params = {
      resource: authResources.DISABLE_TELEGRAM_OTP,
      data
    };
    return await apiWithSnackbar(params);
  },
  disableTelegram: async (data: DisableTelegram) => {
    const params = {
      resource: authResources.DISABLE_TELEGRAM,
      data
    };
    return await apiWithSnackbar(params);
  },
  resetTV: async (data: ResetTvParams) => {
    const params = {
      resource: authResources.RESET_TV,
      data
    };
    return await apiWithSnackbar(params);
  },
  getPendingDeposit: async (data: PendingDepositParams) => {
    const params = {
      resource: authResources.DEPOSIT_PENDING_REQUEST,
      data
    };
    return await apiWithSnackbar(params);
  },
  getAllDeposit: async (data: AllDepositParams) => {
    const params = {
      resource: authResources.DEPOSIT_ALL_REQUEST,
      data
    };
    return await apiWithSnackbar(params);
  },
  rejectDeposit: async (data: RejectDepositParams) => {
    const params = {
      resource: authResources.DEPOSIT_REJECT,
      data
    };
    return await apiWithSnackbar(params);
  },
  acceptDeposit: async (data: AcceptDepositParams) => {
    const params = {
      resource: authResources.DEPOSIT_ACCEPT,
      data
    };
    return await apiWithSnackbar(params);
  },
  getWithdrawDeposit: async (data: WithdrawListParams) => {
    const params = {
      resource: authResources.WITHDRAW_REQUEST,
      data
    };
    return await apiWithSnackbar(params);
  },
  rejectWithdraw: async (data: RejectDepositParams) => {
    const params = {
      resource: authResources.WITHDRAW_REJECT,
      data
    };
    return await apiWithSnackbar(params);
  },
  acceptWithdraw: async (data: AcceptWithdrawParams) => {
    const params = {
      resource: authResources.WITHDRAW_ACCEPT,
      data
    };
    return await apiWithSnackbar(params);
  },
  getAllRequest: async (data: AllTransactionParams) => {
    const params = {
      resource: authResources.ALL_REQUEST,
      data
    };
    return await apiWithSnackbar(params);
  },
  getDepositMethod: async (data: DepositMethodParams) => {
    const params = {
      resource: authResources.DEPOSIT_METHOD,
      data
    };
    return await apiWithSnackbar(params);
  },
  getBankingMethod: async (data: BankingMethodParams) => {
    const params = {
      resource: authResources.BANKING_METHOD,
      data
    };
    return await apiWithSnackbar(params);
  },
  createDepositMethod: async (data: any) => {
    const params = {
      resource: authResources.CREATE_DEPOSIT_METHOD,
      data,
      headers: {
        'Content-Type': 'multipart/form-data',
    },
    };
    return await apiWithSnackbar(params);
  },
  updateDepositMethod: async (data: UpdateMethodParams) => {
    const params = {
      resource: authResources.UPDATE_DEPOSIT_METHOD,
      data
    };
    return await apiWithSnackbar(params);
  },
  getMethodDeleteExpiry: async (data: DeleteExpiryParams) => {
    const params = {
      resource: authResources.DELETE_EXPIRY_DEPOSIT_METHOD,
      data
    };
    return await apiWithSnackbar(params);
  },
  deleteBankMethod: async (data: DeleteMethodParams) => {
    const params = {
      resource: authResources.DELETE_DEPOSIT_METHOD,
      data
    };
    return await apiWithSnackbar(params);
  },
  editDepositMethod: async (data: any) => {
    const params = {
      resource: authResources.EDIT_DEPOSIT_METHOD,
      data,
      headers: {
        'Content-Type': 'multipart/form-data',
    },
    };
    return await apiWithSnackbar(params);
  },
  deleteBets: async (data:DeleteBetsPayload) => {
    const params = {
      resource: authResources.DELETE_BETS,
      data
    };
    return await apiHandler(params);
  },
  getUpdateFancyOrder: async (data:updateFancyPayload) => {
    const params = {
      resource: authResources.UPDATEFANCYORDER,
      data
    };
    return await apiHandler(params);
  },
  getOnlineUserNames: async (data:onlineUserNames) => {
    const params = {
      resource: authResources.ONLINE_USERNAMES,
      data
    };
    return await apiHandler(params);
  },
  getOnlineUserIp: async (data:onlineUserNames) => {
    const params = {
      resource: authResources.ONLINE_USER_IP,
      data
    };
    return await apiHandler(params);
  },
  getOnlineDomainName: async (data:onlineUserNames) => {
    const params = {
      resource: authResources.ONLINE_DOMAIN,
      data
    };
    return await apiHandler(params);
  },
  getLogout: async () => {
    const params = {
      resource: authResources.GET_LOGOUT,
    };
    return await apiHandler(params);
  },
  updateAllowB2C: async (data:userB2CPaylod) => {
    const params = {
      resource: authResources.UPDATE_B2C,
      data
    };
    return await apiHandler(params);
  },
  updateSocialMedia: async (data:userSocialMediaPaylod) => {
    const params = {
      resource: authResources.UPDATE_SOCIAL_MEDIA,
      data
    };
    return await apiHandler(params);
  },
  updateDomainBonus: async (data:domainBonusPaylod) => {
    const params = {
      resource: authResources.UPDATE_DOMAIN_BONUS,
      data
    };
    return await apiHandler(params);
  },
  getPaymentMethod: async (data:any) => {
    const params = {
      resource: authResources.GET_PAYMENT_METHOD,
      data
    };
    return await apiHandler(params);
  },
  getParentPaymentDetails: async (data:any) => {
    const params = {
      resource: authResources.GET_PARENT_PAYMENT,
      data
    };
    return await apiHandler(params);
  },
  getReferCode: async (data:any) => {
    const params = {
      resource: authResources.DETAILSFORADD,
      data
    };
    return await apiHandler(params);
  },
  getUpdateBonus: async (data:updateBonusReq) => {
    const params = {
      resource: authResources.UPDATE_BONUS,
      data
    };
    return await apiHandler(params);
  },
  getWellet: async (data:any) => {
    const params = {
      resource: authResources.WALLET,
      data,
      headers: {
        'Content-Type': 'multipart/form-data',
    },
    };
    return await apiHandler(params);
  },
  getAllDepositNew: async (data: depositNewReq) => {
    const params = {
      resource: authResources.GET_WALLET_DW,
      data
    };
    return await apiWithSnackbar(params);
  },
  getCreateSport: async (data: createReq) => {
    const params = {
      resource: authResources.CREATE_SPORT,
      data
    };
    return await apiWithSnackbar(params);
  },
  getTotalUserCount: async (data: userCountPayload) => {
    const params = {
      resource: authResources.TOTAL_USER_COUNT,
      data
    };
    return await apiWithSnackbar(params);
  },
  getActiveUserCount: async (data: userCountPayload) => {
    const params = {
      resource: authResources.ACTIVE_USER_COUNT,
      data
    };
    return await apiWithSnackbar(params);
  },
  getEnabledTelegram: async (data: enableTelegramPayload) => {
    const params = {
      resource: authResources.ENABLE_TELEGRAM,
      data
    };
    return await apiWithSnackbar(params);
  },
  getRemoveAuth: async (data: RemoveAuthPayload) => {
    const params = {
      resource: authResources.REMOVE_AUTH,
      data
    };
    return await apiWithSnackbar(params);
  },
  getUnlockTrxn: async (data: RemoveAuthPayload) => {
    const params = {
      resource: authResources.UNLOCK_TRXN,
      data
    };
    return await apiWithSnackbar(params);
  },
  setUserStack: async (data: RemoveAuthPayload) => {
    const params = {
      resource: authResources.SET_USER_STACK,
      data
    };
    return await apiWithSnackbar(params);
  },
}